import { render, staticRenderFns } from "./MessageSendBox.vue?vue&type=template&id=6700237a&scoped=true&"
import script from "./MessageSendBox.vue?vue&type=script&lang=js&"
export * from "./MessageSendBox.vue?vue&type=script&lang=js&"
import style0 from "./MessageSendBox.vue?vue&type=style&index=0&id=6700237a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6700237a",
  null
  
)

export default component.exports